export const starlinkTokens = {
  fontFamily: 'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif',
  barHeight: "64px",
  barHeightMobile: "56px",
  triggerSize: "40px",
  panelWidth: "420px",
  radiusSmall: "8px",
  radiusMedium: "12px",
  space: { xs: "4px", sm: "8px", md: "12px", lg: "16px", xl: "24px" },
  motionFast: "140ms",
  motionPanel: "200ms"
} as const;

export const starlinkThemeTokens = {
  dark: {
    bar: "rgba(12, 14, 17, 0.9)",
    barBorder: "rgba(184, 194, 207, 0.16)",
    backdrop: "rgba(12, 14, 17, 0.96)",
    surface: "rgba(28, 31, 36, 0.98)",
    surfaceHover: "rgba(255,255,255,0.07)",
    border: "rgba(184, 194, 207, 0.18)",
    text: "#f2f5f7",
    muted: "#a8b3c0",
    accent: "#b9ed22",
    accentText: "#0d1105"
  },
  light: {
    bar: "rgba(255, 255, 255, 0.92)",
    barBorder: "rgba(23, 35, 27, 0.12)",
    backdrop: "rgba(255, 255, 255, 0.98)",
    surface: "#ffffff",
    surfaceHover: "#f1f7f3",
    border: "#dce5df",
    text: "#17231b",
    muted: "#66746b",
    accent: "#2d804b",
    accentText: "#ffffff"
  },
  immersive: {
    bar: "rgba(7, 20, 32, 0.82)",
    barBorder: "rgba(148, 163, 184, 0.18)",
    backdrop: "rgba(7, 20, 32, 0.96)",
    surface: "rgba(15, 37, 57, 0.98)",
    surfaceHover: "rgba(70, 151, 184, 0.13)",
    border: "rgba(148, 163, 184, 0.18)",
    text: "#e6edf6",
    muted: "#a8b3c7",
    accent: "#22d3ee",
    accentText: "#03131a"
  }
} as const;

/**
 * Document-level tokens shared by the global navigation shell and each
 * independently deployed application body. Consumers receive these as
 * `--star-shell-*` custom properties from `<starlink-navigation>`.
 */
export const starlinkAppSurfaceTokens = {
  dark: {
    pageBg: "#05080f",
    surface: "rgba(12, 17, 27, 0.92)",
    surfaceStrong: "rgba(17, 25, 39, 0.98)",
    border: "rgba(184, 194, 207, 0.18)",
    text: "#f2f5f7",
    muted: "#a8b3c0",
    accent: "#b9ed22",
    grid: "rgba(184, 194, 207, 0.045)",
    shadow: "0 24px 64px rgba(0, 0, 0, 0.32)"
  },
  light: {
    pageBg: "#f5f7f6",
    surface: "rgba(255, 255, 255, 0.94)",
    surfaceStrong: "#ffffff",
    border: "rgba(23, 35, 27, 0.12)",
    text: "#17231b",
    muted: "#66746b",
    accent: "#2d804b",
    grid: "rgba(45, 128, 75, 0.04)",
    shadow: "0 24px 64px rgba(23, 35, 27, 0.12)"
  },
  immersive: {
    pageBg: "#03111d",
    surface: "rgba(7, 28, 46, 0.9)",
    surfaceStrong: "rgba(10, 36, 56, 0.98)",
    border: "rgba(148, 163, 184, 0.18)",
    text: "#e6edf6",
    muted: "#a8b3c7",
    accent: "#22d3ee",
    grid: "rgba(103, 232, 249, 0.055)",
    shadow: "0 24px 64px rgba(0, 8, 18, 0.38)"
  }
} as const;
